function activeCardSwatches(){
  var customSwatches = document.querySelectorAll('.custom-swatch')
  if (customSwatches.length > 1){
    customSwatches.forEach(customSwatch => {
      customSwatch.addEventListener('click', function(e) {
        var getCard = e.target.closest('.product-card')

        /* Update Image */
        var getNewImageSrc = e.target.getAttribute('data-image-src') || undefined
        var getNewImageSrcset = e.target.getAttribute('data-image-srcset') || undefined
        var getNewImageAlt = e.target.getAttribute('data-image-alt') || undefined
        var getOldImage = getCard.querySelector('.product-primary-image')|| undefined
        if (getOldImage != undefined && getNewImageSrc != undefined && getNewImageSrcset != undefined && getNewImageAlt != undefined){
          getOldImage.setAttribute('src', getNewImageSrc)
          getOldImage.setAttribute('srcset', getNewImageSrcset)
          getOldImage.setAttribute('alt', getNewImageAlt)
        }
  
        /* Update Image Hover */
        var getNewImageHoverSrc = e.target.getAttribute('data-image-hover-src') || undefined
        var getNewImageHoverSrcset = e.target.getAttribute('data-image-hover-srcset') || undefined
        var getNewImageHoverAlt = e.target.getAttribute('data-image-hover-alt') || undefined
        var getOldImageHover = getCard.querySelector('.product-secondary-image') || undefined
        if (getOldImageHover != undefined && getNewImageHoverSrc != undefined && getNewImageHoverSrcset != undefined && getNewImageHoverAlt != undefined){
          getOldImageHover.setAttribute('src', getNewImageHoverSrc)
          getOldImageHover.setAttribute('srcset', getNewImageHoverSrcset)
          getOldImageHover.setAttribute('data-srcset', getNewImageHoverSrcset)
          getOldImageHover.setAttribute('alt', getNewImageHoverAlt)
        }
  
        /* Update Title */
        var getNewTitle = e.target.getAttribute('data-title')
        var getOldTitle = getCard.querySelector('.product-card-info a[title]')
        if (getNewTitle != undefined){
          getOldTitle.setAttribute('title', getNewTitle)
          getOldTitle.innerText = getNewTitle
        }

        /* Update Size */
        var getNewSizes = e.target.getAttribute('data-sizes')
        var getOldSizes = getCard.querySelector('.also-in-text')
        if (getNewSizes != undefined){
          getOldSizes.innerText = 'Available in: ' + getNewSizes
        }

        /* Update Price */
        var getNewPrice = e.target.getAttribute('data-price')
        var getOldPrice = getCard.querySelector('ins .amount')
        if (getNewPrice != undefined){
          getOldPrice.innerText = getNewPrice
        }

        /* Update Compare At Price */
        var getNewComparePrice = e.target.getAttribute('data-compare')
        var getOldComparePrice = getCard.querySelector('del .amount')
        if (getNewComparePrice != undefined){
          if (getOldComparePrice != undefined){
            getOldComparePrice.innerText = getNewComparePrice
          } else {
            const comparePrice = document.createElement("del");
            comparePrice.innerHTML = '<span class="amount">' + getNewComparePrice + '</span>';
            getCard.querySelector('.price-line').appendChild(comparePrice);
          }
          getOldPrice.classList.add('red-compared-at-price')
        } else {
          if (getCard.querySelector('del') != undefined){
            getCard.querySelector('del .amount').innerHTML = '';
            getOldPrice.classList.remove('red-compared-at-price')
          }
        }

        /* Update Badge */
        var getNewBadge = e.target.getAttribute('data-badge')
        var getNewBadgeClass = e.target.getAttribute('data-badge-class')
        var badge = getCard.querySelector('.badge')
        if (getNewBadge.length > 0){
          if (badge != undefined){
            badge.innerText = getNewBadge
            badge.classList.remove('final-sale', 'sale', 'exclusive', 'new-arrival', 'out-of-stock')
            if (getNewBadgeClass.length > 0){
              badge.classList.add(getNewBadgeClass)
            }  
          } else {
            const badgeSpan = document.createElement("span");
            badgeSpan.classList.add('badge', 'top', 'left')
            badgeSpan.innerHTML = getNewBadge;
            getCard.querySelector('.product-featured-image').appendChild(badgeSpan);
            badgeSpan.classList.remove('final-sale', 'sale', 'exclusive', 'new-arrival', 'out-of-stock')
            if (getNewBadgeClass.length > 0){
              badgeSpan.classList.add(getNewBadgeClass)
            }
          }
        } else {
          badge.innerText = ''
        }

        /* Update Offer 1 */
        var getNewOffer1 = e.target.getAttribute('data-offer-1')
        var getNewOfferColor1 = e.target.getAttribute('data-offer-1-color')
        var getOldOffer1 = getCard.querySelector('.offer-by-tag[data-offer="1"]')
        if (getNewOffer1 != null){
          if (getOldOffer1 != null){
            getOldOffer1.innerText = getNewOffer1 
          } else {
            const offerSpan1 = document.createElement("span");
            offerSpan1.classList.add('offer-by-tag')
            offerSpan1.setAttribute('data-offer', '1')
            offerSpan1.style.color = getNewOfferColor1;
            offerSpan1.innerHTML = getNewOffer1;
            getCard.querySelector('.product-card-info').appendChild(offerSpan1);
          }
        } else {
          if (getOldOffer1 != null){
            getOldOffer1.innerText = ''
          }
        }

        /* Update Offer 2 */
        var getNewOffer2 = e.target.getAttribute('data-offer-2')
        var getNewOfferColor2 = e.target.getAttribute('data-offer-2-color')
        var getOldOffer2 = getCard.querySelector('.offer-by-tag[data-offer="2"]')
        if (getNewOffer2 != undefined){
          if (getOldOffer2 != undefined){
            getOldOffer2.innerText = getNewOffer2
          } else {
            const offerSpan2 = document.createElement("span");
            offerSpan2.classList.add('offer-by-tag')
            offerSpan2.setAttribute('data-offer', '2')
            offerSpan2.style.color = getNewOfferColor2;
            offerSpan2.innerHTML = getNewOffer2;
            getCard.querySelector('.product-card-info').appendChild(offerSpan2);
          }
        } else {
          if (getOldOffer2 != null){
            getOldOffer2.innerText = ''
          }
        }

        /* Update Offer 3 */
        var getNewOffer3 = e.target.getAttribute('data-offer-3')
        var getNewOfferColor3 = e.target.getAttribute('data-offer-3-color')
        var getOldOffer3 = getCard.querySelector('.offer-by-tag[data-offer="3"]')
        if (getNewOffer3 != undefined){
          if (getOldOffer3 != undefined){
            getOldOffer3.innerText = getNewOffer3
          } else {
            const offerSpan3 = document.createElement("span");
            offerSpan3.classList.add('offer-by-tag')
            offerSpan3.setAttribute('data-offer', '3')
            offerSpan3.style.color = getNewOfferColor3;
            offerSpan3.innerHTML = getNewOffer3;
            getCard.querySelector('.product-card-info').appendChild(offerSpan3);
          }
        } else {
          if (getOldOffer3 != null){
            getOldOffer3.innerText = ''
          }
        }

        /* Update Selected Checkbox */
        getCard.querySelectorAll('.custom-swatch').forEach(customSwatchByCard => {
          customSwatchByCard.classList.remove('checked')
        })
        customSwatch.classList.add('checked')
      });
    });
  }
  
  
  var moreColorsButtons = document.querySelectorAll('.more-colors')
  if (moreColorsButtons.length > 1){
    moreColorsButtons.forEach(moreColorsButton => {
      moreColorsButton.addEventListener('mouseover', function(e) {
        if (e.target != undefined){
          var getCard = e.target.closest('.product-card')
          e.target.classList.add('hidden')
          getCard.querySelectorAll('.custom-swatch.hidden').forEach(hiddenSwatchByCard => {
            hiddenSwatchByCard.classList.remove('hidden')
            hiddenSwatchByCard.classList.add('is-active')
          })
        }
      });
    });
  }
  
  var productCards = document.querySelectorAll('.product-card')
  if (productCards.length > 1){
    productCards.forEach(productCard => {
      productCard.addEventListener('mouseleave', function(e) {
        if (productCard.querySelector('.more-colors') != undefined){
          productCard.querySelector('.more-colors').classList.remove('hidden')
          productCard.querySelectorAll('.custom-swatch.is-active').forEach(showedSwatchByCard => {
            showedSwatchByCard.classList.add('hidden')
            showedSwatchByCard.classList.remove('is-active')
          })
        }
      });
    });
  }
}

activeCardSwatches()